<table mat-table [dataSource]="products" (keydown)="onTableKeyDown($event)"
       class="mat-elevation-z8" aria-label="Tabelle mit Produkten" role="grid" tabindex="-1">
  <ng-container matColumnDef="productTitle">
    <th mat-header-cell *matHeaderCellDef id="productTitleId" class="!pl-6 pr-5">{{ 'delivery-products.product_name' | translate }}</th>
    <td mat-cell role="rowheader" *matCellDef="let element" class="!pl-6 pr-5 py-[.625rem]">
      @if (element.documentId || element.documentUrl) {
        <a
          [routerLink]="enableInlineSelection ? null : ['product', element.id]"
          [attr.role]="enableInlineSelection ? 'button' : 'link'"
          myupdatesFocusableTableItem
          (click)="onLinkClick($event, element)"
          (keydown)="onLinkKeyDown($event, element)"
          id="a_{{element.id}}"
          class="outline-none"
        >
          {{ element.title }}
          @if (!platform.SAFARI) {
            <span class="absolute inset-0 z-[2]" aria-hidden="true"></span>
          }
        </a>
      } @else {
        {{ element.title }}
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="productChangeCategories">
    <th mat-header-cell *matHeaderCellDef id="productChangeCategoriesId" class="pr-5">{{ 'delivery-products.product_change_categories' | translate }}</th>
    <td mat-cell *matCellDef="let element" class="py-[.125rem]" [ngClass]="changeCategoriesVerticalOrientation ? 'w-[11rem]' : 'w-[32rem]'">
      <myupdates-change-categories [changeCategories]="element.changeCategories" [verticalOrientation]="changeCategoriesVerticalOrientation"></myupdates-change-categories>
    </td>
  </ng-container>
  <ng-container matColumnDef="productDeliveryBases">
    <th mat-header-cell *matHeaderCellDef id="productDeliveryBasesId" class="pr-5">{{ 'delivery-products.product_base_delivery_information' | translate }}</th>
    <td mat-cell *matCellDef="let element" class="py-[.625rem] w-52">
      @if (element.deliveredByRdt) {
        <myupdates-delivery-bases
          [deliveryBases]="element.deliveryBases"></myupdates-delivery-bases>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="productDataTransformation">
    <th mat-header-cell *matHeaderCellDef id="productDataTransformationId" class="text-center pr-5">
      {{ 'delivery-products.product_data_transformation' | translate }}</th>
    <td mat-cell *matCellDef="let element" class="text-center pr-5">{{ element.dataTransformation | yesNo }}</td>
  </ng-container>
  <ng-container matColumnDef="productLink">
    <th mat-header-cell *matHeaderCellDef id="productLinkId" class="!pr-10" aria-label="Aktion"></th>
    <td mat-cell *matCellDef="let element" class="!pr-10 w-24">
      @if (element.documentId || element.documentUrl) {
        <div class="flex items-center flex-nowrap justify-end">
          <mat-icon svgIcon="sli-pfeil-rechts-20" aria-label="Details zum Programm anzeigen"></mat-icon>
        </div>
      }
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayDeliveryBasesAndDataTransformation ? displayedColumns : reducedColumns" class="!h-18"></tr>
  <tr mat-row *matRowDef="let row; columns: displayDeliveryBasesAndDataTransformation ? displayedColumns : reducedColumns"
      class="!h-18 focus-within:outline focus-within:outline-2 focus-within:outline-blue-500 focus-within:outline-offset-[-2px]"
      [ngClass]="{'!bg-coldgray-150': selectedProduct?.id === row.id, 'relative': !platform.SAFARI, 'cursor-pointer': row.documentId || row.documentUrl}"
      [attr.aria-selected]="selectedProduct?.id === row.id"
  ></tr>
</table>

